import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { keysToSnake } from '#/api/adapters/wireCase';

/** DELETE `/crm/quotations/{id}`：僅草稿。body：`updatedAt`。 */
export async function deleteDraftQuotation(id, payload) {
  const { data: raw } = await request.delete(`/crm/quotations/${id}`, {
    data: keysToSnake(payload),
  });
  return parseVer4DetailResponse(raw);
}
